import { useTranslation } from 'react-i18next';
import Modal from '../Modal/Modal';
import { PropsWithChildren, useState } from 'react';
import MiniLoader from '../MiniLoader/MiniLoader';
import Button from '../Button';

interface Props {
  isModalOpened: boolean;
  closeModal: () => void;
  title?: string;
  confirmBtnText?: string;
  confirm: (setIsLoading: (v: boolean) => void) => void;
}

export default function ConfirmModal({
  isModalOpened,
  closeModal,
  title = 'Confirmation',
  confirmBtnText = 'OK',
  confirm,
  children,
}: PropsWithChildren<Props>) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const onClickConfirm = () => {
    confirm(setIsLoading);
  };

  return (
    <Modal
      isOpened={isModalOpened}
      close={closeModal}
      title={t(title)}
      isLoading={isLoading}
    >
      <div className='mx-3 pt-2 pb-4 px-3'>
        {children}
        <div className='row row-cols-auto gx-2 mt-2'>
          <div className='col'>
            <Button
              className='d-flex align-items-center'
              type='submit'
              disabled={isLoading}
              data-testid='submit-note-modal-btn'
              onClick={onClickConfirm}
            >
              {isLoading && (
                <MiniLoader className='MiniLoader--sm d-flex align-items-center justify-content-center me-2 MiniLoader--gray' />
              )}
              <span>{t(confirmBtnText)}</span>
            </Button>
          </div>
          <div className='col'>
            <Button styling='outline' onClick={closeModal} disabled={isLoading}>
              {t('Cancel')}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
